import React from 'react';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
    CustomSelectInput,
} from 'candy-commons-components';
import {
    BooleanInput,
    Create,
    required,
    SimpleForm,
    NumberInput,
    useTranslate,
} from 'react-admin';
import SECTION_CHOICES from '../../data/ecommerceHomeSectionChoices.json';

const HomeSectionCmsCreate = (props) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation('resources.ecommerce-home-sections.name'),
            url: 'ecommerce-home-sections',
            icon: <ViewModuleIcon />,
        },
        {
            text: translation('resources.ecommerce-home-sections.create.name'),
            url: '',
        },
    ];
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Create {...props}>
                <SimpleForm redirect="list">
                    <ContainerFieldsList>
                        <CustomSelectInput
                            source="section"
                            choices={SECTION_CHOICES}
                            validate={[required()]}
                            label="Section"
                            helperText="Banner 1/2 are legacy (all brands). Use Banner 1/2 {Brand} so the slot appears only for the brand selected by the user."
                        />
                        <NumberInput
                            source="order"
                            label="Order"
                            validate={[required()]}
                            min={0}
                            max={999}
                        />
                        <BooleanInput
                            source="active"
                            label="Active"
                            defaultValue={false}
                        />
                    </ContainerFieldsList>
                </SimpleForm>
            </Create>
        </>
    );
};

export default HomeSectionCmsCreate;
